module.exports = __webpack_public_path__ + "static/about-content-image-3-891389de88d765a6ebc398f9c53d4893.jpg";